export default {
      id: "first-id-volume-usage",
      viewBox: "0 0 16 20",
      url: __webpack_public_path__ + "img/icons.e72ac2e3.svg#first-id-volume",
      toString: function () {
        return this.url;
      }
    }